<template>
    <div class="box" v-if="campaign.objective">
        <div class="deal-form-title">
            <span v-if="campaign.type === 'deal'">
                {{ campaign.influencer_title }}
            </span>
            <span v-else>
                {{ customizationText('overview_header', 'Overview') }}
            </span>
        </div>

        <div v-html="$sanitize(campaign.objective)"></div>

        <job-tracking :campaign="campaign" v-if="'deal' === campaign.type" />
    </div>
</template>

<script>
    import CampaignCustomizeMixin from '../../../../mixins/CampaignCustomizeMixin';
    import JobTracking from './JobTracking';

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'JobObjective',
        components: { JobTracking },
        /**
         * The component mixins
         *
         * @type {Array}
         */
        mixins: [CampaignCustomizeMixin],

        /**
         * The component properties
         *
         * @type {Object}
         */
        props: {
            /**
             * The campaign
             */
            campaign: {
                type: Object,
                required: true
            }
        }
    };
</script>
